export const
  PUBLIC = 'PUBLIC',
  PUBLIC_LABEL = 'Messages',
  PUBLIC_DESCRIPTION = 'Conversation between buyers and suppliers.',

  PRIVATE = 'PRIVATE',
  PRIVATE_LABEL = 'Notes',
  PRIVATE_DESCRIPTION = isBuyer => `Conversation between ${isBuyer? 'buyers': 'suppliers'} only.`,

  PERSONAL = 'PERSONAL',
  PERSONAL_LABEL = 'Personal Notes',
  PERSONAL_DESCRIPTION = 'Notes visible only to you.',

  MESSAGE_TYPE_OPTIONS = [
    { type: PUBLIC, label: PUBLIC_LABEL, description: () => PUBLIC_DESCRIPTION},
    { type: PRIVATE, label: PRIVATE_LABEL, description: PRIVATE_DESCRIPTION },
    { type: PERSONAL, label: PERSONAL_LABEL, description: () => PERSONAL_DESCRIPTION},
  ],

  USER_MESSAGES = 'user',
  USER_MESSAGES_LABEL = 'User Messages',
  ACCOUNT_MESSAGES = 'account',
  ACCOUNT_MESSAGES_LABEL = 'Account Messages',
  MESSAGES_LABEL = 'Messages';

export function getTypeTitle(type){
  switch(type){
    case PUBLIC:
      return 'Message';
    case PRIVATE:
      return 'Note';
    case PERSONAL:
      return 'Personal Note';
    default:
      return '';
  }
}

export function getTypeDetails(type, isBuyer) {
  switch(type){
    case PUBLIC:
      return {label: PUBLIC_LABEL, description: PUBLIC_DESCRIPTION};
    case PRIVATE:
      return {label: PRIVATE_LABEL, description: PRIVATE_DESCRIPTION(isBuyer)};
    case PERSONAL:
      return {label: PERSONAL_LABEL, description: PERSONAL_DESCRIPTION};
    default:
      return {};
  }
}
